/* eslint-disable react/no-danger */
import React from 'react';
import _ from 'lodash';
import { LazyLoadImage } from 'react-lazy-load-image-component';

export default function TwoColumnsCards({ data, dir, id }) {
  const { cardTitle, cardText, cardItems } = data;
  return (
    <section 
      id={id} 
      className={`${cardTitle !== null 
        ? 'bg-[#f7f7f7] py-10 md:py-16 lg:py-24' 
        : 'pt-[25px] lg:pt-[50px] pb-[50px] lg:pb-[100px]'}`} 
      dir={dir}
      >
      <div className="container max-w-[1200px] mx-auto px-6">
        {cardTitle && (
          <div className="text-center space-y-5 md:space-y-7 pb-8 md:pb-12">
            <h2 className="text-[#4A4A4A] text-clamp20to30 m-0">{cardTitle}</h2>
            {cardText && (
              <div 
              className="font-LibreBaskervilleRegular text-[#4A4A4A] text-clamp13to20 leading-1.5">
                {cardText}
              </div>
            )}
          </div>
        )}

        {cardItems && (
          <div className="grid sm:grid-cols-2 gap-7.5">
            {_.map(cardItems, (card, index) => (
              <div key={index} className="bg-white border border-[#EBEBEB]">
                {_.isEmpty(card.content.image) || (
                  <LazyLoadImage
                    src={card.content.image.url}
                    className="min-h-[100px] object-cover"
                  />
                )}

                <div className="p-5 md:p-6 lg:p-10">
                  <h3
                    dangerouslySetInnerHTML={{ __html: card.content.title }}
                    className="text-clamp14to20 mb-5 ltr:leading-1.5 rtl:leading-1.6"
                  />
                  <div
                    dangerouslySetInnerHTML={{ __html: card.content.cardText }}
                    className="[&>*:last-child]:mb-0 ltr:font-DINRegular rtl:font-GESSTwoDWTCLight
                    rtl:leading-1.6"
                  />
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </section>
  );
}
